import { GuideStepType } from '@/services/apis/guides';

export const STEP_TYPES = [
  { type: GuideStepType.RICH_TEXT, icon: 'Type', label: 'Text', color: 'from-blue-500 to-blue-600' },
  { type: GuideStepType.VIDEO, icon: 'Play', label: 'Video', color: 'from-red-500 to-red-600' },
  { type: GuideStepType.IMAGE, icon: 'Image', label: 'Image', color: 'from-green-500 to-green-600' },
  { type: GuideStepType.QUESTION, icon: 'HelpCircle', label: 'Quiz', color: 'from-purple-500 to-purple-600' },
  { type: GuideStepType.PDF, icon: 'FileText', label: 'PDF', color: 'from-orange-500 to-orange-600' },
] as const;

export const DIFFICULTIES = [
  { value: 'beginner', label: 'Beginner', color: 'success' },
  { value: 'intermediate', label: 'Intermediate', color: 'warning' },
  { value: 'advanced', label: 'Advanced', color: 'danger' },
] as const;

export const LANGUAGES = [
  { value: 'en', label: 'English' },
  { value: 'es', label: 'Spanish' },
] as const;

export const DEFAULT_FORM_VALUES = {
  title: '',
  description: '',
  difficulty: 'beginner' as const,
  estimatedTime: '',
  category: 'Getting Started',
  product: '',
  language: 'en' as const,
  steps: [],
  selectedStepId: null,
} as const;

export const SKELETON_STEPS_COUNT = 3;
export const SKELETON_PROPERTIES_COUNT = 3;
